"use strict";
// Copyright (c) 2026 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
const appConfig = {
    prefix: 'ecash',
    dustSats: 546,
    cashDecimals: 2,
};
exports.default = appConfig;
//# sourceMappingURL=app.js.map